import * as React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
const steps = [{
  number: "1",
  title: "Send your study data & label spec",
  description: "Supply the arc flash study output (equipment list with incident energy / PPE category, boundaries, voltage, IDs, analysis date) as a file or schedule. Evermark recommends a material and format; it does not produce the study."
}, {
  number: "2",
  title: "Get a quote",
  description: "Material, construction, quantity pricing, lead time, and rush options."
}, {
  number: "3",
  title: "Approve the proof",
  description: "Evermark sends a label proof; you confirm the data, fields, and layout in writing. Evermark reproduces the supplied values exactly and does not alter hazard data."
}, {
  number: "4",
  title: "Production",
  description: "Labels are produced on the specified material with in-process inspection."
}, {
  number: "5",
  title: "Ship",
  description: "Durable, install-ready labels, with documentation when the spec requires it."
}];
export default function HowDoYouOrderArcFlashLabels() {
  return <section id="how-do-you-order-arc-flash-labels" className="bg-background py-16 md:py-24 lg:py-32">
      <div className="container mx-auto px-4 md:px-6 max-w-5xl">
        <div className="text-center max-w-3xl mx-auto mb-16 md:mb-24">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-foreground font-default mb-6 tracking-tight">
            How Do You Order Arc Flash Labels?
          </h2>
          <p className="text-lg md:text-xl text-muted-foreground font-sans leading-relaxed">
            Ordering arc flash labels from Evermark Industrial Solutions follows a five-step path built around your study data and a proof.
          </p>
        </div>

        <div className="max-w-4xl mx-auto space-y-12 md:space-y-16 mb-16 md:mb-24">
          {steps.map((step, i) => <div key={i} data-index={i} className="flex flex-col md:flex-row gap-4 md:gap-10 items-start group">
              <div className="text-7xl md:text-8xl font-bold text-primary font-default leading-none shrink-0 md:w-24 transition-transform duration-300 group-hover:scale-105">
                {step.number}
              </div>
              <div className="pt-2 md:pt-4 flex-1">
                <h3 className="text-2xl md:text-3xl font-semibold text-foreground font-default mb-3 md:mb-4">
                  {step.title}
                </h3>
                <p className="text-base md:text-lg text-muted-foreground font-sans leading-relaxed">
                  {step.description}
                </p>
              </div>
            </div>)}
        </div>

        <div className="flex justify-center">
          <Button asChild size="lg" className="font-default text-base md:text-lg px-8 py-6 h-auto">
            <Link to="/ContactPage">
              Request a Quote
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}